/** Tourismo platform id for Hwy3 (newsletter subscribe URLs, etc.). */
export const TOURISMO_PLATFORM_ID = 43;

export const MAIN_NEWSLETTER_SLUG = "main";
